export default __webpack_public_path__ + "static/media/burger.117222a1.jpg";